export const log = async <T>(logNs: string, f: () => Promise<T>): Promise<T> => {
  const now = Date.now();
  const res = await f();
  console.debug(`[${logNs}] start_at=${now} d=${Date.now() - now}`);
  return res;
};
